import _implicitStylesheets from "./appLauncher.css";
import _implicitScopedStylesheets from "./appLauncher.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div${"c0"}${2}></div>`;
const $fragment2 = parseFragment`<a${"a0:data-active"} data-menu="item" role="menuitem"${"a0:href"} class="menu__item${0}" target="_blank" tabindex="-1"${2}><img class="menu__item-img${0}" alt=""${"a1:src"}${2}>${"t2"}</a>`;
const stc0 = {
  classMap: {
    "menu__container": true
  },
  key: 0
};
const stc1 = {
  "type": "loginNavLink"
};
const stc2 = {
  props: {
    "icon": "apps",
    "iconDescription": "App launcher"
  },
  key: 3
};
const stc3 = {
  attrs: {
    "grid": "",
    "axis": "row",
    "flow": "wrap"
  },
  key: 7
};
const stc4 = {
  "size": "1:3"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, ncls: api_normalize_class_name, gid: api_scoped_id, c: api_custom_element, h: api_element, sp: api_static_part, st: api_static_fragment, k: api_key, fid: api_scoped_frag_id, d: api_dynamic_text, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6} = $ctx;
  return [api_element("div", stc0, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc1,
    key: 1,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("button", {
    className: api_normalize_class_name($cmp.menuTriggerClass),
    attrs: {
      "aria-controls": api_scoped_id("menu"),
      "aria-expanded": $cmp.appLauncherExpanded,
      "aria-haspopup": "true",
      "role": "button",
      "data-menu": "trigger",
      "aria-label": $cmp.appLauncherMenu
    },
    key: 2,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.toogleAppLauncher)),
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleTriggerKeyDown))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc2)])]), api_static_fragment($fragment1, 5, [api_static_part(0, {
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.toogleAppLauncher))
    },
    className: api_normalize_class_name($cmp.backDropClassName)
  }, null)]), api_element("div", {
    className: api_normalize_class_name($cmp.menuClassName),
    attrs: {
      "data-menu": "menu",
      "id": api_scoped_id("menu"),
      "tabindex": "0",
      "role": "menu",
      "aria-label": $cmp.appLauncherMenu
    },
    key: 6,
    on: {
      "keydown": _m5 || ($ctx._m5 = api_bind($cmp.handleMenuKeyDown))
    }
  }, [api_element("div", stc3, api_iterator($cmp.menuItems, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return api_element("div", {
      attrs: stc4,
      key: api_key(8, it.value.position)
    }, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc1,
      key: 9,
      on: {
        "analytics": _m6 || ($ctx._m6 = api_bind($cmp.handleAnalytics))
      }
    }, [api_static_fragment($fragment2, 11, [api_static_part(0, {
      attrs: {
        "data-active": it.value.active,
        "href": api_scoped_frag_id(it.value.url)
      }
    }, null), api_static_part(1, {
      attrs: {
        "src": it.value.image
      }
    }, null), api_static_part(2, null, api_dynamic_text(it.value.name))])])]);
  }))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3nsq6pbr9c7";
tmpl.legacyStylesheetToken = "undefined-_appLauncher";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
